import { render, staticRenderFns } from "./ConfirmTemplate.vue?vue&type=template&id=4aa5ac1f&scoped=true"
import script from "./ConfirmTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmTemplate.vue?vue&type=script&lang=js"
import style0 from "./ConfirmTemplate.vue?vue&type=style&index=0&id=4aa5ac1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5ac1f",
  null
  
)

export default component.exports